export default __webpack_public_path__ + "static/media/play.c36c619c.svg";